import API from '../utils/api';
import { GET_FOOD_ITEMS } from '../constants';

export const getFoodItemDetailsById = (id) => {
  return API.get(`/food/item/services/get/${id}/details`);
}

export const getReviews = (id,param) => {
  return API.get(`/review/services/get/reviews/?${param}=${id}&pageNo=1&recordsPerPage=10`);
}

export const deleteitem = (itemId, cbFn) => {
       //console.log("itemId",itemId);
  return API.post(`/food/item/services/delete`,itemId).then((response)=>{
     if(response.data && response.data.status && response.data.status === "success") {
          cbFn(response.data.desc);
     }else if(response.data && response.data.status === "error") {
          cbFn(response.data.desc, true);
     }
  }).catch((error)=>{
      cbFn('Unexpected Error', true)
  })
}

/*export const getFoodItems = () => {
    dispatch({type:"LOADING",payload:{loadingImg:true}})
      return(dispatch)=>{
         return API.get(`${GET_FOOD_ITEMS}`).then((response)=>{
            if(response.data && response.data.status && response.data.status === "success") {
               // console.log(response.data.details.foodItems)
                //cbFn(response.data.desc, true);
                dispatch({type:'LOAD_FOOD_ITEMS',paylod:response.data.details.foodItems})
            } else if(response.data && response.data.status === "error") {
               // cbFn(response.data.desc, true);
            }
        }).catch((error)=>{
            //cbFn('Unexpected Error', true)
        })
      }
  }*/


 export const getFoodItems = (pageno,recordsperpage) => {
      return(dispatch)=>{
         dispatch({type:"LOADING",payload:{isLoading:true}})
          console.log("apiurl",`${GET_FOOD_ITEMS}?pageNo=${pageno}&recordsPerPage=${recordsperpage}`);
         return API.get(`${GET_FOOD_ITEMS}?pageNo=${pageno}&recordsPerPage=${recordsperpage}`).then((response)=>{
            if(response.data && response.data.status && response.data.status === "success") {
                  //console.log("loadeddate",response.data.details.foodItems)
                dispatch({type:'LOAD_FOOD_ITEMS',payload:{
                   pageNo:response.data.details.pageNo,
                   totalPages:response.data.details.totalPages,
                    //totalRecords:response.data.details.totalRecords,
                    fooditems:response.data.details.foodItems,
                    isLoading:false
                  }
                })
            }  
        }) 
      }
  }
  
  export const getcategorieslist = (countryid) => {
    return API.get(`/food/item/services/get/categories?countryId=${countryid}`);
}

  export const getsellerslist = (countryid,sellertype) => {
    //console.log("sellerapi",`/food/seller/services/get/all?countryId=${countryid}&pageNo=1&recordsPerPage=-1`);
       return API.get(`/food/seller/services/get/all/${sellertype}?countryId=${countryid}&pageNo=1&recordsPerPage=-1`);
}
export const getcuisineslist = () => {
        return API.get(`/misc/services/get/cuisines`);
}
export const gettagslist = (countryid) => {
    return API.get(`/food/item/services/get/tags?countryId=${countryid}`);
}

export const getzipcodeslist = (cityId) => {
    //console.log(`/misc/services/get/${cityId}/pincodes`);
    return API.get(`/misc/services/get/${cityId}/pincodes`);
}
export const getmetricslist = () => {
    return API.get(`/food/item/services/get/metrics`);
}

export const addsellerdish = (dish, cbFn) => {
   //console.log("url",'http://3.232.110.80:8080/enjoyfresh/api/food/item/services/create'); 
      return API.post(`/food/item/services/create`, dish).then((response)=>{
         // console.log("response",response)
       if(response.data && response.data.status && response.data.status === "success") {
          cbFn(response.data.desc);
         } else if(response.data && response.data.status === "error") {
          cbFn(response.data.desc, true);
       }  
  }) 
}

export const updatesellerdish = (dish, cbFn) => {
      return API.post(`/food/item/services/update`, dish).then((response)=>{
      if(response.data && response.data.status && response.data.status === "success") {
        cbFn(response.data.desc);
       } else if(response.data && response.data.status === "error") {
        cbFn(response.data.desc, true);
     } 
   })   
}
